import React, { Component } from 'react';
import { translate } from 'react-i18next';

class LanguageSwitcher extends Component {
	constructor(props) {
		super(props);
		const { i18n } = this.props;
		this.state = { language: i18n.language };

		this.handleChangeLanguage = this.handleChangeLanguage.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ language: nextProps.i18n.language });
	}

	handleChangeLanguage(lng) {
		const { i18n } = this.props;
		i18n.changeLanguage(lng);
	}

	renderLanguageChoice({ code, label }) {
		var source = code + '.svg';
		return (
			<a key={code} style={{ paddingRight: '3px', paddingTop: '3px', display: 'inline-block', width: '20px' }} onClick={() => this.handleChangeLanguage(code)}>
				<img className="manImg" src={source} />
			</a>
		);
	}

	render() {
		const languages = [{ code: 'en', label: 'English' }, { code: 'nl', label: 'Dutch' }];

		return languages.map(language => this.renderLanguageChoice(language));
	}
}

export default translate('translations')(LanguageSwitcher);



// WEBPACK FOOTER //
// ./src/LanguageSwitcher.js